// TODO: we need to come up with system solution for region and locale, right now they merged together
// list of supported locales
export const LOCALES = {
  CH: 'de-CH',
  DE: 'de',
  EN: 'en',
  NL: 'nl',
} as const;

// currently used for MOV because of AT hardcodes and for shipping
// TODO: this one have capitalized letters and AT, should be united or dismissed
export enum CountryCode {
  DE = 'DE',
  CH = 'CH',
  AT = 'AT',
  NL = 'NL',
}

export type Locale = (typeof LOCALES)[keyof typeof LOCALES];

// Language level only. Region level attributes (topLevelDomain, ...) live in the shop config.
export interface LocaleMeta {
  label: string;
  isVisible: boolean;
}

// TODO: should be reworked, should switch language, but should show available languages per region, should not switch region.
export const LOCALE_META: Record<Locale, LocaleMeta> = {
  [LOCALES.DE]: { label: 'Deutsch', isVisible: true },
  [LOCALES.CH]: { label: 'Deutsch (Schweiz)', isVisible: false },
  [LOCALES.EN]: { label: 'English', isVisible: true },
  [LOCALES.NL]: { label: 'Nederlands', isVisible: true },
};

/** Look up a locale's attributes, falling back to DE for unknown/missing locales. */
export const getLocaleMeta = (locale?: string): LocaleMeta => {
  return (locale ? LOCALE_META[locale as Locale] : undefined) ?? LOCALE_META[LOCALES.DE];
};

export const getLanguageCode = (locale?: string): string => {
  return locale?.split('-')[0] || LOCALES.DE;
};

export const getUpperCaseLanguageCode = (locale?: string): string => {
  return getLanguageCode(locale).toUpperCase();
};
